import { Button } from "./ui/button";
import { Home, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export const NotFound = () => {
  return (
    <section className="min-h-screen flex items-center justify-center px-4">
      <div className="text-center max-w-md mx-auto">
        <div className="glass-verse p-12 rounded-3xl mb-8">
          <h1 className="text-8xl font-bold mb-4 bg-gradient-to-r from-primary to-foreground text-transparent bg-clip-text">
            404
          </h1>
          <h2 className="text-2xl font-semibold mb-4">Page Not Found</h2>
          <p className="text-muted-foreground mb-8">
            The page you're looking for seems to have wandered off the path.
            Let's get you back on track.
          </p>
          <blockquote className="text-lg italic text-muted-foreground border-l-4 border-primary pl-4 mb-8">
            "Your word is a lamp for my feet, a light on my path."
            <footer className="text-sm mt-2 font-semibold">— Psalm 119:105</footer>
          </blockquote>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild variant="outline" size="lg">
            <Link to="/">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </Link>
          </Button>
          <Button asChild size="lg">
            <Link to="/">
              <Home className="w-4 h-4 mr-2" />
              Home
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
